/** Kept separate from the lazy page router so classification can be tested
 * without importing app providers or loading optional page implementations. */
const APP_PATHS = new Set([
  "/subscribe", "/onboarding", "/one-more-thing", "/dashboard", "/tasks",
  "/schedule", "/calendar", "/contacts", "/messaging", "/flows", "/pipeline",
  "/analytics", "/goals", "/classes", "/sessions", "/admin", "/website",
  "/flows/referral-generation", "/flows/testimonial-request",
  "/flows/past-client-reactivation", "/website/blog", "/website/pages",
]);
export function isApplicationRoutePath(location: string): boolean {
  return APP_PATHS.has(location) ||
    location.startsWith("/contacts/") ||
    location.startsWith("/flows/") ||
    location.startsWith("/website/area/") ||
    location.startsWith("/website/media/") ||
    location.startsWith("/website/campaign/") ||
    location.startsWith("/website/blog/") ||
    location.startsWith("/website/pages/") ||
    location.startsWith("/website/slide/");
}
